import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PhoneState" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from "@/service/main/system";
import {useStore} from "@/store";
import dayjs from "dayjs";
import {ref} from "vue";
import PageModal from "@/components/PageModal.vue";
import {modalConfig} from './config/modal.config'
import {ElMessage} from "element-plus";
import {initEmptyParam} from "@/hooks/useInitParam";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneState',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCallerList = async () => {
  let callersData = await getListData('/main/phoneState/getCaller', {})
  const callersItem = searchFormConfig.formItems.find((item) => item.field === 'caller')
  callersItem!.options = callersData.map((item: any) => {
    return {title: item, value: item}
  })
}
getCallerList()

const queryParam = {
  importTimeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ]
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}

const getStatusName = (item: any) => {
  switch (item) {
    case 1:
      return '已接通';
    case 2:
      return '未接通';
    case 3:
      return '意向';
    case 4:
      return '加个微';
    case 5:
      return '加企微';
    case 6:
      return '已成交';
    default:
      return '--';
  }
}

const modalTitle = ref('状态标签')
const url = ref('')
const pageModalRef = ref<InstanceType<typeof PageModal>>()
const defaultInfo = ref({})

const handleStateConfirm = (item: any) => {
  url.value = `main/phoneState/updateStatus/${item.id}`
  pageModalRef.value!.dialogVisible = true
  defaultInfo.value = {...item}
}

const handleImportSuccess = () => {
  ElMessage({
    type: 'success',
    message: '导入成功'
  })
}

const handleImportError = (res: any) => {
  console.log(res)
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "phoneState",
      downFilename: "电话状态查询.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onImportSuccess: handleImportSuccess,
      onImportError: handleImportError
    }, {
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          onClick: ($event: any) => (handleStateConfirm(scope.row))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(getStatusName(scope.row.status)), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"]),
    _createVNode(PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: defaultInfo.value,
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "phoneState",
      url: url.value,
      validOtherInfo: () => true
    }, null, 8, ["defaultInfo", "modalConfig", "title", "url"])
  ]))
}
}

})